import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { useNavigate } from "react-router-dom";
import './Applications.css'

import {
    TextField, InputAdornment, IconButton,
    Stack, Pagination, FormControl,
    Select, MenuItem, Button, CircularProgress
} from '@mui/material'

import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { format } from 'date-fns'

import ApplicationsTable from '../../components/dashboard/applications/ApplicationsTable.js';
import { useApplications } from '../../hooks/useApplications.js';


const Applications = ({ status }) => {
    const navigate = useNavigate();
    const [localStatus, setLocalStatus] = useState("");
    const [localStartDate, setLocalStartDate] = useState(null);
    const [localEndDate, setLocalEndDate] = useState(null);
    const [isDateRangeOpen, setIsDateRangeOpen] = useState(false)
    const today = new Date();
    const action = "VIEW_APPLICATION";

    const initialFilters = useMemo(() => {
        return {
            applicationStatus: status === 'open' ? ["PENDING"] : ["APPROVED", "REJECTED"],
            startDate: null,
            endDate: null,
            applicationId: '',
            sortBy: null,
            sortDirection: null
        };
    }, [status]);

    const {
        data,
        isLoading,
        error,
        pagination,
        filters,
        updateFilters,
        fetchApplications
    } = useApplications(initialFilters);

    const handleSort = useCallback((columnId) => {
        console.log("Column Id is: ", columnId)

        if (columnId) {
            const newDirection = filters.sortBy === columnId && filters.sortDirection === "asc" ? "desc" : "asc";
            updateFilters({
                sortBy: columnId,
                sortDirection: newDirection
            });
        }
    }, [filters.sortBy, filters.sortDirection, updateFilters]);

    const handleRowClick = useCallback(async (result, submitViewedNote, setIsPopupOpen, setPopupMessage, setIsLocked, setLockCode) => {
        const isLocked = await submitViewedNote(result?.applicationNumber, action, setIsPopupOpen, setPopupMessage, setIsLocked, setLockCode);
        if (!isLocked) {
            // Store the application status in session storage
            sessionStorage.setItem("APPLICATION_ID", result?.applicationNumber);
            console.log("Now will navigate to /review");
            navigate(`/review`, {
                state: {
                    applicationId: result?.applicationNumber,
                    applicantStatus: result?.applicationStatus,
                },
            });
        }
    }, [navigate]);

    const handleSearch = (event) => {
        const searchValue = event.target.value;
        console.log("Search value: ", searchValue)
        updateFilters({ applicationId: searchValue });
    };

    const handleStatusChange = (event) => {
        const value = event.target.value;
        console.log("the value is: ", value)

        if (value === 'STATUS') {
            setLocalStatus('STATUS');
            updateFilters({ applicationStatus: ['APPROVED', 'REJECTED'] });
        } else {
            setLocalStatus(value);
            updateFilters({ applicationStatus: value });
        }
    };

    const handleDateChange = (value) => {
        // const { value } = event.target;
        console.log("Name", value)
        // updateFilters({ [type === 'start' ? 'startDate' : 'endDate']: value });
    };

    const handleStateDateField = (value) => {
        console.log("New value: ", value)
        setLocalStartDate(value)
    }

    const handleEndDateField = (value) => {
        console.log("New value: ", value)
    }

    const handleStartDateChange = (value) => {
        setLocalStartDate(value)

    }

    const handleEndDateChange = (value) => {
        if (localStartDate || value > localStartDate) {
            setLocalEndDate(value);
        }
    }

    const handleDateRangeButton = (e) => {
        console.log("I got clicked")
        e.preventDefault();
        setIsDateRangeOpen(prev => !prev)
    }

    const handleResetDateRange = async (e) => {
        e.preventDefault();
        setLocalStartDate(null)
        setLocalEndDate(null)

        if (filters.startDate || filters.endDate) {
            updateFilters({ startDate: null, endDate: null })
            setIsDateRangeOpen(false)
        }
    }

    const handleDateRangeSubmit = async (e) => {
        e.preventDefault(); // Prevent form submission/page reload
        if (localStartDate && localEndDate) {
            updateFilters({ startDate: localStartDate, endDate: localEndDate });
            setIsDateRangeOpen(false);
        }
    }

    const closeDateRange = () => {
        setIsDateRangeOpen(false);
    };

    const getDateRangeButtonText = () => {
        if (localStartDate && localEndDate) {
            return `${format(localStartDate, "MMM dd, yyyy")} - ${format(localEndDate, "MMM dd, yyyy")}`;
        }
        if (localStartDate) {
            return `${format(localStartDate, "MMM dd, yyyy")} - Select End Date`;
        }
        return "Start date - End date";
    };

    if (error) {
        console.log("Error: ", error)
        return errorUIComponent(status, error, fetchApplications);
    }

    return (
        <div className='applications-layout'>
            <div className="title-container">
                <span className="title-text">Total Applications</span>
                <span className="applications-number">{pagination?.totalElements}</span>
            </div>

            <div className="inputs-container">
                <div className="date-input-container">
                    <Button
                        variant="contained"
                        onClick={handleDateRangeButton}
                        endIcon={<KeyboardArrowDownIcon />}
                        sx={{
                            backgroundColor: '#D4ECEF',
                            color: '#264E5A',
                            borderRadius: '8px',
                            boxShadow: 'none',
                            border: '1px solid #264E5A',
                            height: '40px',
                            textTransform: 'none',
                        }}>
                        {getDateRangeButtonText()}
                    </Button>

                    {isDateRangeOpen &&
                        <div className='date-range-modal'>
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    right: '1rem',
                                    top: '1rem'
                                }}
                                onClick={closeDateRange}>
                                <CloseIcon />
                            </IconButton>

                            <div className='calendars-container'>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <div className='calendar-wrap'>
                                        <span>Start date</span>
                                        {/* TODO: Fix the date field state */}
                                        {/* <DateField
                                                        size='small'
                                                        value={localStartDate}
                                                        sx={{ padding: '0rem 1.35rem' }}
                                                        onChange={(newValue) => handleStateDateField(newValue)}
                                                    /> */}
                                        <DateCalendar
                                            id='startDate'
                                            value={localStartDate}
                                            maxDate={today}
                                            onChange={newValue => handleStartDateChange(newValue)}
                                            sx={{
                                                "& .Mui-selected": {
                                                    backgroundColor: "#264E5A !important", // Changes the selected date color
                                                    color: "white", // Ensures the text is readable
                                                },
                                                "& .Mui-selected:hover": {
                                                    backgroundColor: "#D4ECEF", // Darker teal on hover
                                                }
                                            }} />
                                    </div>
                                    <div className='calendar-wrap'>
                                        <span>End date</span>
                                        {/* TODO: Fix the date field state */}
                                        {/* <DateField
                                                        size='small'
                                                        value={localEndDate}
                                                        sx={{ padding: '0rem 1.35rem' }}
                                                        onChange={(newValue) => handleEndDateField(newValue)}
                                                    /> */}
                                        <DateCalendar
                                            id='endDate'
                                            value={localEndDate}
                                            minDate={localStartDate || undefined}
                                            maxDate={today}
                                            disabled={!localStartDate}
                                            onChange={newValue => handleEndDateChange(newValue)}
                                            sx={{
                                                "& .Mui-selected": {
                                                    backgroundColor: "#264E5A !important", // Changes the selected date color
                                                    color: "white", // Ensures the text is readable
                                                },
                                                "& .Mui-selected:hover": {
                                                    backgroundColor: "#D4ECEF", // Darker teal on hover
                                                }
                                            }} />
                                    </div>
                                </LocalizationProvider>
                            </div>

                            <div className='date-btns-container'>
                                <Button
                                    variant='outlined'
                                    autoFocus
                                    onClick={(e) => handleResetDateRange(e)}
                                    sx={{
                                        padding: '0.75rem 2rem',
                                        borderRadius: '8px',
                                        border: '1px solid #00707E',
                                        color: '#00707E',
                                        textTransform: 'none',
                                    }}>
                                    Reset
                                </Button>

                                <Button
                                    variant='contained'
                                    onClick={(e) => handleDateRangeSubmit(e)}
                                    disabled={!localStartDate || !localEndDate}
                                    sx={{
                                        padding: '0.75rem 2rem',
                                        boxShadow: 'none',
                                        backgroundColor: '#00707E',
                                        borderRadius: '8px',
                                        border: '1px solid #00707E',
                                        textTransform: 'none',
                                    }}>
                                    Apply
                                </Button>
                            </div>

                        </div>}
                </div>

                {filters.applicationStatus.length !== 1 &&
                    <FormControl size="small" sx={{
                        minWidth: 120, height: '40px',
                        paddingLeft: '1rem', marginRight: 'auto',
                    }}>
                        <Select
                            value={localStatus}
                            onChange={handleStatusChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            sx={{
                                color: '#264E5A', fontWeight: '500', fontSize: '14px',
                                borderRadius: '8px', height: '100%', outline: 'none',
                                border: '1px solid #264E5A', backgroundColor: '#D4ECEF'
                            }}>
                            <MenuItem value="" hidden={true}>STATUS</MenuItem>
                            <MenuItem value='STATUS'>ALL</MenuItem>
                            <MenuItem value='APPROVED'>APPROVED</MenuItem>
                            <MenuItem value='REJECTED'>REJECTED</MenuItem>
                        </Select>
                    </FormControl>
                }

                <div className="search-input-container">
                    <TextField
                        size='small'
                        variant="outlined"
                        className="search-input"
                        placeholder="Search by Application ID"
                        value={filters?.applicationId}
                        onChange={(e) => { handleSearch(e) }}
                        sx={{
                            borderRadius: '8px', border: '1px solid #264E5A',
                            "& .MuiOutlinedInput-root": {
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderRadius: '8px',
                                    border: "1px solid #264E5A", // Change border color on hover
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderRadius: '8px',
                                    border: "1px solid #264E5A", // Change border color on focus
                                },
                            },
                        }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }
                        }}
                    />
                </div>
            </div>

            {isLoading ? (
                <div className={'loading-container'}>
                    <CircularProgress sx={{ color: "#264E5A" }} />
                </div>
            ) : (
                data?.length === 0 ? (
                    errorUIComponent(status, error, fetchApplications)
                ) : (
                    <div>
                        <ApplicationsTable
                            data={data}
                            onRowClick={handleRowClick}
                            sortConfig={{
                                sortBy: filters.sortBy,
                                sortDirection: filters.sortDirection,
                                onSort: handleSort
                            }}
                        />

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}>
                            <Stack spacing={2}>
                                <Pagination
                                    count={pagination.totalPages}
                                    page={pagination.currentPage + 1}
                                    onChange={(_, page) => fetchApplications(page - 1)}
                                    showFirstButton
                                    showLastButton
                                    sx={{
                                        '& .Mui-selected': {
                                            backgroundColor: '#264E5A !important',
                                            color: 'white !important',
                                        },
                                        '& .Mui-selected:hover': {
                                            backgroundColor: '#264E5A !important',
                                            color: 'white !important',
                                        }
                                    }}
                                />
                            </Stack>
                        </div>
                    </div>
                )
            )}
        </div>
    )
}

const errorUIComponent = (status, error, fetchApplications) => {
    return (
        <div className={'error-container'}>
            <h2>{error ? "Oops, Something went wrong!" : `No ${status === 'open' ? "Open" : "Closed"} Applications Found`}</h2>
            <p>{error || "There are no applications matching your criteria."}</p>
            <Button
                variant="outlined"
                sx={{
                    borderColor: "#264E5A",
                    color: "#264E5A",
                    textTransform: 'none',
                }}
                onClick={() => fetchApplications()}
            >
                Try again
            </Button>
        </div>
    )
}

export default Applications